import { CommonModule } from '@angular/common'
import { Component, Input, inject, computed } from '@angular/core'

import { IconComponent, TagComponent, TypographyComponent } from '@hyperkit'

import { SessionService } from '@hunt/services'

@Component({
  standalone: true,
  imports: [CommonModule, TypographyComponent, IconComponent, TagComponent],
  selector: 'hyperkit-report-query-header',
  templateUrl: './report-query-header.component.html',
  styleUrls: ['./report-query-header.component.scss'],
})
export class ReportQueryHeaderComponent {
  readonly session = inject(SessionService)
  readonly loaded = computed(
    () => !this.session.loading() && this.session.activeHunt() !== null,
  )
  @Input() isPivot = false
  @Input() numPivots = 0
  @Input() category = ''
  @Input() parentQuery = ''
}
